import { twClassMerge } from '@healthhub/react-ui';
import type { FormInstance } from 'antd';
import { Form } from 'antd';
import type { Store } from 'antd/es/form/interface';
import type { ConfigType } from 'dayjs';

import { useLayoutViewContext } from '@shared/context';

import FilterComponent from './FilterComponent';

export interface FilterHandleFormProps {
  className?: string;
  dateRangeDaysLimit: number;
  dateRangeOffset?: number;
  filterBtnText?: string;
  fixedEndDate?: ConfigType;
  fixedStartDate?: ConfigType;
  form: FormInstance;
  handleResetFilters: () => void;
  initialValuesForm: Store;
  maxDate?: ConfigType;
  minDate?: ConfigType;
  onFinish: (values) => void;
}

const FilterHandleForm = ({
  className,
  dateRangeDaysLimit,
  dateRangeOffset,
  filterBtnText,
  fixedEndDate,
  fixedStartDate,
  form,
  handleResetFilters,
  initialValuesForm,
  maxDate,
  minDate,
  onFinish,
}: FilterHandleFormProps) => {
  const { isStandardView } = useLayoutViewContext();

  return (
    <div className="size-full">
      <Form
        className={twClassMerge('filter-form h-full px-4', isStandardView && 'h-[75vh]')}
        form={form}
        initialValues={initialValuesForm}
        layout="horizontal"
        onFinish={onFinish}
      >
        <FilterComponent
          className={className}
          dateRangeDaysLimit={dateRangeDaysLimit}
          dateRangeOffset={dateRangeOffset}
          filterBtnText={filterBtnText}
          fixedEndDate={fixedEndDate}
          fixedStartDate={fixedStartDate}
          form={form}
          handleResetFilters={handleResetFilters}
          maxDate={maxDate}
          minDate={minDate}
        />
      </Form>
    </div>
  );
};

export default FilterHandleForm;
